import { createContext, useContext } from "react";
import type { UserProfile } from "../api/userService";

export interface UserContextType {
  user: UserProfile | undefined;
  isLoading: boolean;
}

const defaultContextValue: UserContextType = {
  user: undefined,
  isLoading: false,
};

export const UserContext = createContext<UserContextType>(defaultContextValue);

export const useUserContext = () => useContext(UserContext);
